module.exports = __webpack_public_path__ + "img/pickup_driving.385a0d5e.svg";